<template lang="pug">
  .moonphase-quiz
    flip-card(
      @flip="onFlip"
      :disabled="state === states.answer || state === states.done || state === states.finished"
      )
      template(v-slot:front)
        card-back
          span.card-back-title(
            v-if="state === states.start"
            )
            | Luna {{ quiz.data.phase }}
          quiz-answer(
            v-else
            @done="result => updateState(states.done, result)"
          )


      template(v-slot:back)
        card-back
          .answer
            .moon(:style="{'background-image': `url(/img/moon/${quiz.data.phase}.jpg)`}")
              | {{ quiz.moonPhase.phase }}
            .phase
              h3
                .slanted {{ quiz.moonPhase.title[locale] }}
              rich-text-renderer(:document="quiz.moonPhase.description[locale]")
</template>

<script>
import { mapState } from 'vuex'

import RichTextRenderer from 'contentful-rich-text-vue-renderer'
import FlipCard from './FlipCard'
import CardBack from './CardBack'
import CardFront from './CardFront'
import QuizAnswer from './QuizAnswer'

const states = {
  start: 0,
  showMoonPhase: 1,
  answer: 2,
  done: 3,
  finished: 4
};

export default {
  components:{
    RichTextRenderer,
    FlipCard,
    CardFront,
    CardBack,
    QuizAnswer
  },
  props: {
    quiz: Object
  },
  data() {
    return {
      states,
      state: states.start
    };
  },
  computed: {
    ...mapState('locale', ['locale']),
  },
  methods: {
    onFlip({ flipped }) {
      if (flipped && this.state === this.states.start) {
        this.updateState(this.states.showMoonPhase);
      }
      if (!flipped && this.state === this.states.showMoonPhase) {
        this.updateState(this.states.answer);
      }
    },
    updateState(state, value=null) {
      if (this.state === this.states.finished) {
        return;
      }
      this.state = state;
      if (this.state === this.states.done) {
        this.$emit('done', this.quiz, value);
        this.state = this.states.finished;
      }
    }
  },
  watch: {
    quiz: function (newQuiz, oldQuiz) {
      if (newQuiz.id !== oldQuiz.id) {
        this.state = this.states.start;
      }
    }
  }
}
</script>

<style lang="stylus" scoped>

  .answer, .moon
    display flex
    align-items center
    flex-direction column

  .answer .phase
    margin 0 1rem

  span.card-back-title
    font-font-weight 900
    font-size 3em

  h3
    font-size 1em
    & > div
      background-color black
      border-color black

  .moon
    height 3.125em
    width 3.125em
    justify-content center
    margin .75em 0
    font-weight 600
    background-size contain
    mix-blend-mode screen
    color #eee
    text-shadow #000 0 0 2px
</style>
